module.exports = __webpack_public_path__ + "img/aboutUslogo.e18ca34e.png";